const zhMessages = {
  "chat.end": "重新开始您的聊天对话",
  "chat.cancel": "取消",
  "chat.endall": "结束聊天",
  "chat.cookie": "此数字助理使用 cookie 来确保您获得最佳体验",
  "chat.learn": "了解更多",
  "chat.minimize": "最小化",
  "chat.hide": "关",
  "chat.hidebot.text": "关闭将使头像消失 15 分钟",
  "chat.hidebot": "关闭机器人",
  "chat.restart": "重新开始",
  "switch.language": "切换语言",
  "switch.property": "开关属性",
  "restart.converstation": "重新开始聊天",
  "chat.endtext": "您确定要结束当前聊天吗？",
  "check.availabity": "检查可用性",
  "check.availabity.submit": "提交",
  "check.availabity.cancel": "取消",
  "check.availabity.adults": "成年人 ",
  "check.availabity.children": "孩子们",
  "check.availabity.child.age": "年龄 - 儿童",
  "feedback.leave": "留下反饋信息",
  "feedback.leave.message": "请留言",
  "placeholder.name": "Name",
  "placeholder.firstName": "名字",
  "placeholder.lastName": "姓氏",
  "placeholder.email": "电子信箱",
  "placeholder.phoneNumber": "Phone Number",
  "placeholder.zipcode": "Zip Code",
  "caseform.title": "提交案例",
  "caseform.system": "系统",
  "caseform.loading.systems": "正在加载系统...",
  "caseform.select.system": "选择系统",
  "caseform.error.systems": "加载系统时出错",
  "caseform.scenario": "场景",
  "caseform.loading.scenarios": "正在加载场景...",
  "caseform.select.scenario": "选择场景",
  "caseform.error.scenarios": "加载场景时出错",
  "caseform.topic": "主题",
  "caseform.loading.topics": "正在加载主题...",
  "caseform.select.topic": "选择主题",
  "caseform.error.topics": "加载主题时出错",
  "caseform.subject": "主题",
  "caseform.description": "描述",
  "caseform.submit": "提交",
  "caseform.cancel": "取消",
  "caseform.success.title": "案例已创建",
  "caseform.success.message": "您的案例已成功创建。",
  "caseform.success.caseNumber": "案例编号：",
  "caseform.success.ok": "确定",
  "simpleaction.title": "选择一个动作",
  "simpleaction.body":
    "请选择以下选项之一：{br}{b}创建案例{/b}以提交支持请求，或 {b}开始聊天{/b} 立即与代理连接。",
  "simpleaction.startchat": "开始聊天",
  "simpleaction.createcase": "创建案例",
  "caseform.error.generic": "案例创建时发生错误。",
  "caseform.error.generic.message": "创建您的案例时发生错误。请稍后再试。",
};
export default zhMessages;
